import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/campaign/$campaignId')({
  async loader({ context, params }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/campaign');
    const title = i18n.t(`Campaign – ${params.campaignId} | MINT`);
    return { title };
  },
  head: (ctx) => {
    return {
      meta: [
        {
          title: ctx.loaderData?.title,
        },
      ],
    };
  },
});
